module.exports = __webpack_public_path__ + "img/storm.6afbc6b2.webp";